import React, {useEffect, useState} from 'react';

import {BrowserRouter as Router, Switch, Route, Link, NavLink, useHistory, useLocation} from 'react-router-dom';

import {motion} from 'framer-motion';
import axios from 'axios';

import './menuOption.css'
import ListProducts  from '../listaProductos/listaProducto'
import ListProducts2  from '../listaProductos/listaProducto2'
import ListaDeProductos from '../listaProductos/listaProducto';
import Pedidos from '../listaProductos/pedidos/pedidos'
import ShowListProduct from '../products/shoawListproducts';
import URL from '../../config/config-server-api'
import PageMessagePaymentControl from '../listaProductos/paymeControlUse/pageMessagePaymentControl';

const MenuOtionsMiTienda =()=>{
    let history = useHistory();
    let location = useLocation();

    const [paymentControlData, setPaymentControlDate] =useState({});

    const [alertState, setAlertState] = useState(false);

    useEffect(() => {
       history.push('/mitienda/home');
       paymentControlUse();
    }, []);
    

    // function control the payment use service   
    const paymentControlUse =(contRequest=0)=>{
        const idNegocio=process.env.REACT_APP_ID_TIENDA;
        try {
            if(idNegocio!='' && idNegocio.length===24){

                var url = URL.UrlshowPaymetnCotrol+idNegocio;
                axios.get(url)
                .then(data=>{
                    console.log(data);
                    if(data.status===200){
                        setPaymentControlDate(
                            data.data.result
                        )
                    }
                })
                .catch(err=>{
                    console.log({err})
                    if(contRequest>2)return;
                    paymentControlUse(contRequest+1)
                })

            }
        } catch (error) {
            console.log('error in payment control')
        }
    }


    const routes = [
        {
            path:'/mitienda/home',
            component:ListProducts,
        },
        {
            path: '/mitienda/pedidos',
            component:Pedidos
        },{
            path: '/mitienda/productos',
            component:ShowListProduct
        }
    ]

    // control message modal
    const showMessagePaymetnControl=()=>{
        setAlertState(true)
        
        setTimeout(()=>{
            setAlertState(false)
        },10000)    
    }

    return(
        <>
        {
            alertState?
            <PageMessagePaymentControl textMessage={"El plan del servicio a finalizado, por favor comuniquece con el proveedor para renovar su plan o adquirir uno nuevo"} />
            :''
        }
        <motion.div initial={{x:-40, opacity:0}} animate={{ x:0,opacity:1}} transition={{ease: "easeOut",duration:0.4}}
        // style={{background:'#004C3F'}}
        
        

        id="menu-options-owner"
        className="fixed sm:inline bottom-0 text-white w-screen sm:w-40 h-16 sm:h-screen z-10">
                

                <div className="area" />
                <nav className="main-menu ">
                <ul className=" flex flex-row px-6 sm:px-1  justify-between sm:flex-col pt-2">
                    <NavLink to="/mitienda/home">
                    <li className="a">
                        <a id="text-and-icon" href="#">
                            <i className="fas fa-store"></i>
                            <span className="nav-text">
                            Inicio
                            </span>
                        </a>
                    </li>
                    </NavLink>
                    {
                        paymentControlData?.state==="active"?
                        <NavLink to="/mitienda/pedidos">
                        <li className="has-subnav a">
                            <a href="#" id="text-and-icon">
                            <i class="fas fa-box-open"></i>
                                <span className="nav-text">
                                Pedidos
                                </span>
                            </a>
                        </li>
                        </NavLink>
                        :
                        <li className="has-subnav a">
                            <a onClick={()=>showMessagePaymetnControl()} id="text-and-icon">
                            <i class="fas fa-box-open"></i>
                                <span className="nav-text">
                                Pedidos
                                </span>
                            </a>
                        </li>
                    }
                    
                    {
                        paymentControlData?.state==="active"?
                        <NavLink  to="/mitienda/productos">
                        <li className="has-subnav a py-0">
                        <a href="#" id="text-and-icon" className=" flex flex-rows-1">
                            <svg xmlns="http://www.w3.org/2000/svg" className="mx-auto sm:mx-0 sm:my-auto  h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM14 11a1 1 0 011 1v1h1a1 1 0 110 2h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 110-2h1v-1a1 1 0 011-1z" />
                            </svg>
                            <span onClick={()=>{console.log(location.pathname)}} className=" nav-text">
                            Productos
                            </span>
                        </a>
                        </li>
                        </NavLink>
                        :
                        <li className="has-subnav a py-0 cursor-pointer">
                        <a onClick={()=>showMessagePaymetnControl()} id="text-and-icon" className=" flex flex-rows-1">
                            <svg xmlns="http://www.w3.org/2000/svg" className="mx-auto sm:mx-0 sm:my-auto  h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM14 11a1 1 0 011 1v1h1a1 1 0 110 2h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 110-2h1v-1a1 1 0 011-1z" />
                            </svg>
                            <span onClick={()=>{console.log(location.pathname)}} className=" nav-text">
                            Productos
                            </span>
                        </a>
                        </li>

                    }
                   
                    
                    <li className="has-subnav a">
                    <a href="#" id="text-and-icon">
                    <i class="fas fa-user-check"></i>
                        <span className="nav-text">
                        Clientes
                        </span>
                    </a>
                    </li>
                    <li className="b">
                    <a href="#" id="text-and-icon">
                        <i className="fa fa-bar-chart-o" />
                        <span className="nav-text">
                        Estadisticas
                        </span>
                    </a>
                    </li>
                    <li className="a">
                    <a href="#" id="text-and-icon">
                    <i class="fab fa-adversal"></i>
                        <span className="nav-text">
                        Marketing
                        </span>
                    </a>
                    </li>
                    <li className="b">
                    <a href="#" id="text-and-icon">
                        <i className="fa fa-table" />
                        <span className="nav-text">
                        Google sheets
                        </span>
                    </a>
                    </li>
                    
                    <li className="b">
                    <a href="#" id="text-and-icon">
                        <i className="fa fa-info " />
                        <span className="nav-text">
                        Documentacion
                        </span>
                    </a>
                    </li>
                    <li className="b">
                    <a href="#" id="text-and-icon">
                        <i className="fa fa-map-marker" />
                        <span className="nav-text">
                        Mapa
                        </span>
                    </a>
                    </li>
                </ul>
                {/* <ul className="logout">
                    <li>
                    <a href="#" id="text-and-icon">
                        <i className="fa fa-power-off" />
                        <span className="nav-text">
                        Cerrar sesión
                        </span>
                    </a>
                    </li>  
                </ul> */}

               

                </nav>
            
        </motion.div>
                <Switch>
                    {
                        console.log('navlink --> switch'),
                        routes.map((route,i)=>{
                                console.log('...Swith')
                                console.log(route);
                                return <RouteWithSubRoutes key={i}{...route} />
                        })
                    }
                </Switch>

        </>
    )
}


const RouteWithSubRoutes =(route)=>{
    console.log('...func RouteWith SubRoutes')
    console.log(route)
    console.log(route.path)
    console.log(route.component)
    
    return(
        <Route
           exact path={route.path}
           component={route.component}
           data={"tobias espinoza"}
        />
    )

}

export default MenuOtionsMiTienda;